import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'safeResourceUrl',
    standalone: false
})
export class SafeResourceUrlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(url: any): SafeResourceUrl | string {
    if (!url) return '';
    const urlStr = String(url).trim();

    // 1. Allow data: URLs (base64)
    if (urlStr.startsWith('data:')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(urlStr);
    }

    // 2. Allow blob: URLs
    if (urlStr.startsWith('blob:')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(urlStr);
    }

    // 3. Allow only specific domains: subdomains of realworld.fi and mypinata.cloud
    try {
      const parsedUrl = new URL(urlStr);
      const hostname = parsedUrl.hostname.toLowerCase();
      if (
        hostname === 'realworld.fi' || 
        hostname.endsWith('.realworld.fi') ||
        hostname === 'mypinata.cloud' ||
        hostname.endsWith('.mypinata.cloud')
      ) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(urlStr);
      }
    } catch (e) {
      // Invalid URL format
    }

    console.warn('Blocked unsafe resource URL:', urlStr);
    return '';
  }
}
